/**
 * Customer Url Builder utils
 */
export abstract class CustomerUrlBuilderUtil {
    public static notFound(): string {
        return '/not-found';
    }

    // ===============================================================
    // ===============================================================

    public static customer(customerUUID?: string): string {
        return `/customer/${customerUUID}`;
    }

    // ===============================================================
    // ===============================================================

    public static customerOrganizations(customerUUID?: string): string {
        return `${CustomerUrlBuilderUtil.customer(customerUUID)}/organization`;
    }

    // ===============================================================
    // ===============================================================

    public static customerOrganization(customerUUID?: string, organizationUUID?: string): string {
        return `${CustomerUrlBuilderUtil.customer(customerUUID)}/organization/${organizationUUID}`;
    }
    public static customerOrganizationHierarchyLocation(
        customerUUID?: string,
        organizationUUID?: string,
        locationUUID?: string
    ): string {
        return `${CustomerUrlBuilderUtil.customerOrganization(customerUUID, organizationUUID)}/location/${locationUUID}`;
    }

    // ===============================================================
    // ===============================================================

    public static customerProjects(customerUUID?: string): string {
        return `${CustomerUrlBuilderUtil.customer(customerUUID)}/project`;
    }

    // ===============================================================
    // ===============================================================

    public static customerProject(customerUUID?: string, projectUUID?: string): string {
        return `${CustomerUrlBuilderUtil.customer(customerUUID)}/project/${projectUUID}`;
    }

    // ===============================================================
    // ===============================================================

    public static customerGroups(customerUUID?: string): string {
        return `${CustomerUrlBuilderUtil.customer(customerUUID)}/groups`;
    }

    // ===============================================================
    // ===============================================================

    public static customerServiceRequests(customerUUID?: string): string {
        return `${CustomerUrlBuilderUtil.customer(customerUUID)}/service-request`;
    }

    // ===============================================================
    // ===============================================================

    public static customerServiceRequest(customerUUID?: string, serviceRequestUUID?: string): string {
        return `${CustomerUrlBuilderUtil.customer(customerUUID)}/service-request/${serviceRequestUUID}`;
    }

    // ===============================================================
    // ===============================================================

    public static settings(customerUUID?: string): string {
        return `${CustomerUrlBuilderUtil.customer(customerUUID)}/settings`;
    }
    public static settingsUserRoles(customerUUID?: string): string {
        return `${CustomerUrlBuilderUtil.settings(customerUUID)}/user-roles`;
    }
    public static settingsCustomerUserMemberships(customerUUID?: string): string {
        return `${CustomerUrlBuilderUtil.settings(customerUUID)}/customer-user-memberships`;
    }
    public static settingsObjectStore(customerUUID?: string): string {
        return `${CustomerUrlBuilderUtil.settings(customerUUID)}/object-store`;
    }
    public static settingsFiles(customerUUID?: string): string {
        return `${CustomerUrlBuilderUtil.settings(customerUUID)}/files`;
    }
}
